import React from 'react';
import { FunctionComponent } from 'react';

import { TreeNode } from '../../types/interfaces';

interface DeleteNodeDialogProps {
  selectedItem: TreeNode | null;
}
const DeleteNodeDialog: FunctionComponent<DeleteNodeDialogProps> = ({
  selectedItem
}) => {
  if (!selectedItem) return null;
  const isEmployee = selectedItem.data?.toLowerCase() === 'сотрудник';
  const isArea = selectedItem.data?.toLowerCase() === 'участок';
  return (
    <div className="confirmation-content">
      <span>
        Вы уверены, что хотите удалить <b>{selectedItem.data}</b>{' '}
        {selectedItem.label}
        {isEmployee && <label> из участка</label>}?
        {isEmployee && (
          <label>
            <br />
            Сотрудник может быть назначен на наряд.
          </label>
        )}
        {isArea && (
          <label>
            <br />
            Сотрудники участка могут быть назначены на наряд.
          </label>
        )}
        <br /> Данную операцию невозможно отменить.
      </span>
    </div>
  );
};
export default DeleteNodeDialog;
